import { useEffect, useState } from "react";
import {useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import PageWrapper from "../layouts/Index";
import { BiSolidLeftArrowCircle } from "react-icons/bi";

const CustomerDetails = () => {
  const userId = useSelector((state) => state?.user?.user?.id);
  const customerStatus = useSelector((state) => state?.customersStatus);
  const params = useParams();
  const status = params.status;
  const [activeCustomer, setActiveCustomer] = useState({});

  const handleVerifyPayment = () => {
    console.log("Hello...");
  };

  const handleActivateBundle = () => {
    console.log("Activating bundles....");
  };

  const goBack = () => {
    window.history.back();
  };

  useEffect(() => {
    // Fetch customer details from local storage
    let userInStorage = localStorage.getItem("onboarded-customer-profile");
    const userTypeStorage = userInStorage ? JSON.parse(userInStorage) : null;
    setActiveCustomer(userTypeStorage);
  }, [status, userId]);

  return (
    <PageWrapper>
      <PageTitle title="Customer's Details" />
      <div className="row overflow-scroll">
        <div className="col-sm-12 col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="list-group">
                <div className="card">
                  <div
                    className="list-group-item flex-column align-items-start"
                  >
                    <div className="customer-details-box">
                      <div>
                        <img
                          src={activeCustomer?.customer_image_url}
                          alt="customer's_profile_picx"
                          className="customer-profile-picx"
                        />
                      </div>
                      <div className="customer-details-box-details">
                        <h5 className="text-muted">
                          {activeCustomer?.firstName} {activeCustomer?.lastName}{" "}
                          <strong>(07031259186)</strong>
                        </h5>
                        <p className="text-muted">
                          Precustomer-ID:{" "}
                          {activeCustomer?.id || activeCustomer?.customer_id}
                        </p>
                        <p className="text-muted">Msisdn: {activeCustomer?.msisdn}</p>
                        <p className="text-muted">
                          Onboarding Status: {activeCustomer?.onboardingStatus}
                        </p>
                        <p className="text-muted">
                          Date Onboarded: {activeCustomer?.dateOnboarded}
                        </p>
                      </div>
                      <div>
                        <div>
                          <div
                            className="badge badge-primary pt-2 pb-3 px-4 mr-2"
                            onClick={handleVerifyPayment}
                          >
                            {activeCustomer?.isDevicedReleased
                              ? "DEVICE RELEASED"
                              : "DEVICE NOT RELEASED"}
                          </div>
                          <div
                            className="badge badge-success pt-2 pb-3 px-4"
                            onClick={handleActivateBundle}
                          >
                            {activeCustomer?.isDeviceActivated
                              ? "DEVICE ACTIVATED"
                              : "DEVICE NOT ACTIVATED"}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="back-icon" onClick={goBack}>
                  <BiSolidLeftArrowCircle size={26} />
                  <span className="ml-1">Go Back</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default CustomerDetails;
